import React from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

const BeforeAfterSlider = ({ beforeImage, afterImage, beforeLabel = "Before", afterLabel = "After", title, description, darkMode = false }) => {
  return (
    <div className="flex flex-col">
      {title && (
        <h3 className={`text-xl font-bold mb-3 text-center ${darkMode ? 'text-white' : 'text-[#003366]'}`}>{title}</h3>
      )}
      <div className={`rounded-xl overflow-hidden shadow-lg ${darkMode ? 'border-2 border-[#CFB973]' : 'border-2 border-gray-200'}`}>
        <ReactCompareSlider
          itemOne={
            <ReactCompareSliderImage
              src={beforeImage}
              alt={beforeLabel}
              style={{ objectFit: 'cover' }}
            />
          }
          itemTwo={
            <ReactCompareSliderImage
              src={afterImage}
              alt={afterLabel}
              style={{ objectFit: 'cover' }}
            />
          }
          position={50}
          style={{ height: '350px' }}
          handle={
            <div className="flex items-center justify-center w-full h-full">
              <div className="w-1 h-full bg-white shadow-lg"></div>
              <div className="absolute w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center border-2 border-[#CFB973]">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#003366" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 8L22 12L18 16"></path>
                  <path d="M6 8L2 12L6 16"></path>
                </svg>
              </div>
            </div>
          }
        />
        <div className={`flex justify-between px-4 py-2 ${darkMode ? 'bg-[#003366]/50 border-t border-[#CFB973]/30' : 'bg-gray-50 border-b border-gray-200'}`}>
          <span className={`text-sm font-medium ${darkMode ? 'text-white/80' : 'text-gray-600'}`}>{beforeLabel}</span>
          <span className={`text-sm font-medium ${darkMode ? 'text-[#CFB973]' : 'text-[#003366]'}`}>{afterLabel}</span>
        </div>
      </div>
      {description && (
        <p className={`text-sm mt-3 text-center leading-relaxed px-2 ${darkMode ? 'text-white/80' : 'text-gray-600'}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default BeforeAfterSlider;
